import {
  createApiFactory,
  createPlugin,
  createRoutableExtension,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/core-plugin-api';
import { rootRouteRef } from './routes';
import { CostClient, costApiRef } from './api/CostApi';

export const costPlugin = createPlugin({
  id: 'cost',
  routes: { root: rootRouteRef },
  apis: [
    createApiFactory({
      api: costApiRef,
      deps: { discoveryApi: discoveryApiRef, fetchApi: fetchApiRef },
      factory: ({ discoveryApi, fetchApi }) =>
        new CostClient({ discoveryApi, fetchApi }),
    }),
  ],
});

/** What the cluster spends, mounted at /cost. */
export const CostPage = costPlugin.provide(
  createRoutableExtension({
    name: 'CostPage',
    component: () => import('./components/CostPage').then(m => m.CostPage),
    mountPoint: rootRouteRef,
  }),
);
